import CategoryCreateForm from 'components/common/CateogyCreateForm';
import { useCategory } from 'hooks/api';
import { useParams } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { Button, Form, message } from 'antd';
import { useMutation } from 'react-query';
import { editCategory } from 'services/category.service';
import { uploadFile } from 'services/storage.service';

import styles from '../../common/CateogyCreateForm/index.module.scss';

const CategoryEdit = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const { data: category } = useCategory(id!);
  const { mutateAsync: update } = useMutation(editCategory);
  const { mutateAsync: upload } = useMutation(uploadFile);

  const formationCategory = useCallback((c: Category) => ({
    seoTranslation: { translation: c?.seo?.translation },
    root: { translation: c.translation },
    categoryDescription: c.description,
    description: c?.seo?.description,
    keywords: c?.seo?.keywords,
    title: c?.seo?.title,
    image: c.image,
    link: c.link,
    name: c.name,
  }), []);

  useEffect(() => {
    if (category) {
      form.setFieldsValue(formationCategory(category));
    }
  }, [category]);

  const handleFinish = useCallback(async (result, file) => {
    let { image } = result;

    if (file?.originFileObj) {
      const formData = new FormData();
      formData.append('image', file.originFileObj);
      formData.append('path', `category/${result.link}`);
      const uploaded = await upload(formData).catch((e) => {
        message.error(e.message);
        return null;
      });
      if (!uploaded) return;
      image = uploaded.data;
    }

    const payload = {
      name: result.name,
      seo: {
        translation: result?.seoTranslation?.translation,
        description: result.description,
        keywords: result.keywords,
        title: result.title,
      },
      description: result.categoryDescription,
      translation: result.root.translation,
      link: result.link,
      image,
    };

    update({ name: id, category: payload }).then(() => {
      message.success('Category updated!');
    });
  }, [update, upload]);

  return (
    <div>
      <CategoryCreateForm form={form} onFinish={handleFinish} />
      <Button className={styles.save} onClick={() => form.submit()} type='primary'>Update category</Button>
    </div>
  );
};

export default CategoryEdit;
